import { Link } from "@tanstack/react-router";

export default function NotFoundPage() {
  return (
    <div className="flex min-h-[70vh] flex-col items-center justify-center px-4 text-center">
      <p className="font-mono text-xs tracking-wide text-gray-500 uppercase tabular-nums">
        404
      </p>
      <h1 className="mt-3 max-w-[24ch] text-4xl font-semibold tracking-tight text-balance text-gray-900 md:text-5xl lg:text-6xl">
        We couldn't find that page
      </h1>
      <p className="mt-5 max-w-[44ch] text-lg text-pretty text-gray-500 md:text-xl">
        The link may be broken, or the role may have closed. Try browsing
        what's open right now.
      </p>
      <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
        <Link
          to="/search"
          className="bg-polaris-orange rounded-lg px-5 py-3 text-base font-semibold text-white shadow-sm transition-colors hover:bg-orange-700 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-orange-400"
        >
          Browse jobs
        </Link>
        <Link
          to="/"
          className="text-base font-medium text-gray-600 transition-colors hover:text-gray-900"
        >
          Back to home
          <span aria-hidden="true" className="ml-1">
            →
          </span>
        </Link>
      </div>
    </div>
  );
}
